<template>
	<div class="pt-2">
		<VIcon
			class="am-blue--text"
		>
			{{ arrowRight }}
		</VIcon>
		<slot />
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import { mdiArrowRight } from '@mdi/js';
	import { VIcon } from 'vuetify/lib/components';
	import Component from 'vue-class-component';

	@Component({
		components: {
			VIcon
		}
	})
	export default class SubSection extends Vue {
		arrowRight = mdiArrowRight;
	}
</script>
